import React from 'react'
import { ChatBubbleIcon, ChevronDownIcon } from './icons'

type ChatLauncherProps = {
  open: boolean
  unreadCount?: number
  panelId: string
  openLabel: string
  closeLabel: string
  onClick: () => void
}

export const ChatLauncher: React.FC<ChatLauncherProps> = ({
  open,
  unreadCount = 0,
  panelId,
  openLabel,
  closeLabel,
  onClick,
}) => {
  // Launcher stays mounted but is hidden while the panel is open (kit rule).
  if (open) {
    return (
      <button
        type="button"
        className="wc-launcher"
        aria-label={closeLabel}
        aria-expanded={true}
        aria-controls={panelId}
        onClick={onClick}
      >
        <ChevronDownIcon />
      </button>
    )
  }

  const badge = unreadCount > 9 ? '9+' : String(unreadCount)
  return (
    <button
      type="button"
      className="wc-launcher"
      aria-label={openLabel}
      aria-expanded={false}
      aria-controls={panelId}
      onClick={onClick}
    >
      <ChatBubbleIcon />
      {unreadCount > 0 && (
        <span className="wc-badge" aria-hidden="true">
          {badge}
        </span>
      )}
    </button>
  )
}
